import React, { useEffect } from 'react';
import './index.less';

let flag = true;

export default () => {
  useEffect(() => {
    if (flag) {
      flag = false;
      let ele = document.getElementById('elements');
      let tag = document.createElement('elements-api')
      tag.setAttribute('apiDescriptionUrl', `${process.env.REACT_APP_SUPPLIER_APP_HOST}`)
      tag.setAttribute('router', 'hash')
      tag.setAttribute('hideSchemas', true)
      ele.append(tag)
    }

    setTimeout(() => {
      let aAll = document.querySelector('.sl-border-t')
      aAll.style.display = 'none'
    }, 1000)

  }, [])
  return <div id="elements"></div>
}